import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/Main.vue'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

export const routes = [{
		path: "/",
		name: "home",
		component: Main,
		redirect: '/',
		meta: {
			menuName: '网站首页',
			menuId: 'A'
		},
		children: [{
			path: "/",
			name: "homeIndex",
			meta: {
				isMenu: true,
				menuName: '首页'
			},
			component: () => import( /* webpackChunkName: "index" */ '../views/index.vue')
		}, {
			path: "/volunteerHome/elegantShow/:contentId",
			name: "volunteerHomeElegantDetail",
			component: () => import( /* webpackChunkName: "volunteerHomeElegantDetail" */
				'../views/volunteerHome/elegantShow/detail.vue'),
			meta: {
				level: 3,
				menuName: '风采展示详情',
				menuId: 'A_D4_1'
			},
		}, {
			path: "/search",
			name: "search",
			component: () => import( /* webpackChunkName: "PartyBuildingGardenDetail" */
				'../views/search.vue'),
			meta: {
				mode: 99,
				level: 2,
				hideBreadcrumb: true,
				menuName: '搜素'
			},
		}, {
			path: "/privacyClause",
			name: "privacyClause",
			component: () => import( /* webpackChunkName: "behExhibitionnDetail" */
				'../views/privacyClause.vue'),
			meta: {
				level: 2,
				hideBreadcrumb: true,
				mode: 99
			}
		}, {
			path: "/questionnaire",
			name: "questionnaire",
			component: () => import( /* webpackChunkName: "behExhibitionnDetail" */
				'../views/questionnaire.vue'),
			meta: {
				menuName: '问卷调查',
				level: 2,
				hideBreadcrumb: true,
				mode: 99
			}
		}]
	}, {
		path: "/cultureAround",
		name: "cultureAround",
		component: Main,
		redirect: '/cultureAround/activity',
		meta: {
			menuName: '身边文化',
			isMenu: true,
			hasClick: false,
			menuId: 'B'
		},
		children: [{
			path: "activity",
			name: "culturalActivity",
			component: () => import( /* webpackChunkName: "culturalActivity" */ '../views/cultureAround/activity/index.vue'),
			meta: {
				level: 2,
				mode: 3,
				menuName: '文化活动',
				hideBreadcrumb: true,
				menuId: 'A_B1'
			},
		}, {
			path: "activity/:contentId",
			name: "culturalActivityDetail",
			component: () => import( /* webpackChunkName: "culturalActivityDetail" */
				'../views/cultureAround/activity/detail.vue'),
			meta: {
				level: 3,
				menuName: '活动报名',
				menuId: 'A_B1'
			},
		}, {
			path: "info",
			name: "culturalInfo",
			component: () => import( /* webpackChunkName: "culturalInfo" */ '../views/cultureAround/info/index.vue'),
			meta: {
				level: 2,
				mode: 3,
				menuId: 'A_B2',
				hideBreadcrumb: true,
				menuName: '文化资讯'
			},
		}, {
			path: "info/:contentId",
			name: "culturalInfoDetail",
			component: () => import( /* webpackChunkName: "culturalInfoDetail" */ '../views/cultureAround/info/detail.vue'),
			meta: {
				level: 3,
				menuId: 'A_B2',
				menuName: '文化资讯'
			},
		}]
	}, {
		path: "/brilliantEHome",
		name: "brilliantEHome",
		component: Main,
		redirect: '/brilliantEHome/encore',
		meta: {
			menuName: '精彩E家',
			isMenu: true,
			menuId: 'C'
		},
		children: [{
			path: "encore",
			name: "behEncore",
			component: () => import( /* webpackChunkName: "brilliantEHomeFC" */ '../views/brilliantEHome/encore/index.vue'),
			meta: {
				level: 2,
				mode: 3,
				menuName: '精彩返场',
				hideBreadcrumb: true,
				menuId: 'A_C2'
			},
		}, {
			path: "encore/:contentId",
			name: "behEncoreDetail",
			component: () => import( /* webpackChunkName: "brilliantEHomeFCD" */ '../views/brilliantEHome/encore/detail.vue'),
			meta: {
				level: 3,
				menuName: '精彩返场',
				menuId: 'A_C2_1'
			},
		}, {
			path: "train",
			name: "behTrain",
			component: () => import( /* webpackChunkName: "brilliantEHomePX" */ '../views/brilliantEHome/train/index.vue'),
			meta: {
				level: 2,
				mode: 3,
				menuName: '精彩培训',
				hideBreadcrumb: true,
				menuId: 'A_C3'
			},
		}, {
			path: "train/:contentId",
			name: "behTrainDetail",
			component: () => import( /* webpackChunkName: "brilliantEHomePXD" */ '../views/brilliantEHome/train/detail.vue'),
			meta: {
				level: 3,
				menuName: '精彩培训',
				menuId: 'A_C3_1'
			},
		}, {
			path: "show",
			name: "behShow",
			component: () => import( /* webpackChunkName: "behShow" */ '../views/brilliantEHome/show/index.vue'),
			meta: {
				level: 2,
				mode: 3,
				menuName: '精彩演出',
				hideBreadcrumb: true,
				menuId: 'A_C5'
			},
		}, {
			path: "show/:contentId",
			name: "behShowDetail",
			component: () => import( /* webpackChunkName: "brilliantEHomeYCD" */ '../views/brilliantEHome/show/detail.vue'),
			meta: {
				level: 3,
				menuName: '精彩展览',
				menuId: 'A_C5_1'
			},
		}, {
			path: "exhibition",
			name: "behExhibitionn",
			component: () => import( /* webpackChunkName: "behExhibitionn" */ '../views/brilliantEHome/exhibition/index.vue'),
			meta: {
				level: 2,
				mode: 3,
				menuName: '精彩展览',
				hideBreadcrumb: true,
				menuId: 'A_C6'
			},
		}, {
			path: "ndcncGov",
			href: "https://www.culturedc.cn",
			meta: {
				level: 2,
				menuName: '国家文化云',
				menuId: 'A_C7'
			},
		}, {
			path: "bjszwhgOrg",
			href: "https://www.bjszwhg.org.cn",
			meta: {
				level: 2,
				menuName: '北京数字文化馆',
				menuId: 'A_C8'
			},
		}, {
			path: "exhibition/:contentId",
			name: "behExhibitionnDetail",
			component: () => import( /* webpackChunkName: "behExhibitionnDetail" */
				'../views/brilliantEHome/exhibition/detail.vue'),
			meta: {
				level: 3,
				menuName: '精彩展览',
				menuId: 'A_C6_1'
			},
		}, {
			path: "/feedback",
			name: "feedback",
			component: () => import( /* webpackChunkName: "behExhibitionnDetail" */
				'../views/feedback.vue'),
			meta: {
				level: 2,
				hideBreadcrumb: true,
				mode: 99,
				menuId: 'A_I4',
				menuName: '意见反馈'
			}
		}, {
			path: "/entryForm",
			name: "entryForm",
			component: () => import( /* webpackChunkName: "behExhibitionnDetail" */
				'../views/entryForm.vue'),
			meta: {
				level: 3,
				hideBreadcrumb: true,
				mode: 99,
				menuId: 'A_D7',
				menuName: '志愿者报名'
			}
		}]
	}, {
		path: "/volunteerHome",
		name: "volunteerHome",
		component: Main,
		redirect: '/volunteerHome/index',
		meta: {
			menuName: '志愿者之家',
			isMenu: true,
			menuId: 'D',
			hasClick: false
		},
		children: [{
			path: "index",
			name: "volunteerHomeIndex",
			component: () => import( /* webpackChunkName: "volunteerHomeIndex" */ '../views/volunteerHome/index.vue'),
			redirect: '/volunteerHome/intro',
			children: [{
				path: "/volunteerHome/intro",
				name: "volunteerHomeIntro",
				component: () => import( /* webpackChunkName: "volunteerHomeIntro" */ '../views/volunteerHome/intro/index.vue'),
				meta: {
					level: 2,
					mode: 3,
					menuName: '区文化志愿者简介',
					menuId: 'A_D0'
				},
			}, {
				path: "/volunteerHome/institution",
				name: "volunteerHomeInstitution",
				component: () => import( /* webpackChunkName: "volunteerHomeInstitution" */
					'../views/volunteerHome/institution/index.vue'),
				meta: {
					level: 2,
					mode: 3,
					menuName: '制度规范',
					menuId: 'A_D1'
				},
			}, {
				path: "/volunteerHome/institution/:contentId",
				name: "volunteerHomeInstitutionDetail",
				component: () => import( /* webpackChunkName: "volunteerHomeInstitutionDetail" */
					'../views/volunteerHome/institution/detail.vue'),
				meta: {
					level: 3,
					menuName: '制度规范',
					menuId: 'A_D1_1'
				},
			}, {
				path: "/volunteerHome/joinUs",
				name: "volunteerHomeJoinUs",
				component: () => import( /* webpackChunkName: "volunteerHomeIntro" */
					'../views/volunteerHome/joinUs/index.vue'),
				meta: {
					level: 2,
					mode: 3,
					menuName: '加入我们',
					menuId: 'A_D2'
				},
			}, {
				path: "/volunteerHome/enroll",
				name: "volunteerHomeEnroll",
				component: () => import( /* webpackChunkName: "volunteerHomeEnroll" */
					'../views/volunteerHome/enroll/index.vue'),
				meta: {
					level: 3,
					mode: 2,
					menuName: '报名',
					menuId: 'A_D3_1'
				},
			}, {
				path: "/volunteerHome/elegantShow",
				name: "volunteerHomeElegantShow",
				component: () => import( /* webpackChunkName: "volunteerHomeElegantShow" */
					'../views/volunteerHome/elegantShow/index.vue'),
				meta: {
					level: 2,
					mode: 3,
					menuName: '风采展示',
					menuId: 'A_D4'
				},
			}, {
				path: "/volunteerHome/project",
				name: "volunteerHomeProject",
				component: () => import( /* webpackChunkName: "volunteerHomeProject" */
					'../views/volunteerHome/project/index.vue'),
				meta: {
					level: 2,
					mode: 3,
					menuName: '志愿项目',
					menuId: 'A_D5'
				},
			}, {
				path: "/volunteerHome/onlineTraining",
				name: "volunteerHomeOnlineTraining",
				component: () => import( /* webpackChunkName: "volunteerHomeOnlineTraining" */
					'../views/volunteerHome/onlineTraining/index.vue'),
				meta: {
					level: 2,
					mode: 3,
					menuName: '在线培训',
					menuId: 'A_D6'
				},
			}],

		}, {
			path: "/volunteerHome/onlineTraining/:contentId",
			name: "volunteerHomeOnlineTrainingDetail",
			component: () => import( /* webpackChunkName: "volunteerHomeOnlineTraining" */
				'../views/volunteerHome/onlineTraining/detail.vue'),
			meta: {
				level: 3,
				menuName: '在线培训',
				menuId: 'A_D6_1'
			},
		}, {
			path: "/volunteerHome/project/:contentId",
			name: "volunteerHomeProjectDetail",
			component: () => import( /* webpackChunkName: "volunteerHomeProjectDetail" */
				'../views/volunteerHome/project/detail.vue'),
			meta: {
				level: 3,
				menuName: '志愿者项目详情',
				menuId: 'A_D5_1'
			},
		}]
	}, 
	
	{
		path: "/culturalMap",
		name: "culturalMap",
		component: Main,
		meta: {
			menuName: '文化地图',
			isMenu: true,
			menuId: 'F'
		},
		redirect: '/culturalMap/index',
		children: [{
			path: "index",
			name: "culturalMapIndex",
			component: () => import( /* webpackChunkName: "culturalMapIndex" */ '../views/culturalMap/index.vue'),
			meta: {
				level: 3,
				menuId: 'A_F_1',
				menuName: '文化地图'
			}
		}, {
			path: "detail/:contentId",
			name: "culturalMapDetail",
			component: () => import( /* webpackChunkName: "culturalMapDetail" */ '../views/culturalMap/detail.vue'),
			meta: {
				level: 3,
				menuId: 'A_F_2',
				menuName: '文化地图'
			}
		}],
	}, {
		path: "/lch",
		name: "lch",
		component: Main,
		meta: {
			menuName: '大兴非遗',
			isMenu: true,
			menuId: 'G'
		},
		redirect: '/lch/index',
		children: [{
			path: "index",
			name: "lchIndex",
			component: () => import( /* webpackChunkName: "lchIndex" */ '../views/lch/index.vue'),
			redirect: '/lch/intro',
			children: [{
				path: "/lch/intro",
				name: "lchIntro",
				component: () => import( /* webpackChunkName: "lchIntro" */ '../views/lch/intro/index.vue'),
				meta: {
					level: 2,
					mode: 3,
					menuName: '非遗介绍',
					menuId: 'A_G1'
				},
			}, {
				path: "/lch/publicity",
				name: "lchPublicity",
				component: () => import( /* webpackChunkName: "lchPublicity" */ '../views/lch/publicity/index.vue'),
				meta: {
					level: 2,
					mode: 3,
					menuName: '非遗公示',
					menuId: 'A_G2'
				},
			}, {
				path: "/lch/policy",
				name: "lchPolicy",
				component: () => import( /* webpackChunkName: "lchPolicy" */ '../views/lch/policy/index.vue'),
				meta: {
					level: 2,
					mode: 3,
					menuName: '非遗项目方针政策',
					menuId: 'A_G3'
				},
			}, {
				path: "/lch/protect",
				name: "lchProtect",
				component: () => import( /* webpackChunkName: "lchPolicy" */ '../views/lch/protect/index.vue'),
				meta: {
					level: 2,
					mode: 3,
					menuName: '非遗传承保护',
					menuId: 'A_G4'
				}
			}, {
			path: "/lch/publicity/:contentId",
			name: "lchPublicityDetail",
			component: () => import( /* webpackChunkName: "lchPublicityDetail" */ '../views/lch/publicity/detail.vue'),
			meta: {
				level: 3,
				menuName: '非遗公示',
				menuId: 'A_G_2'
			},
		}, {
			path: "/lch/policy/:contentId",
			name: "lchPolicyDetail",
			component: () => import( /* webpackChunkName: "lchPublicityDetail" */ '../views/lch/policy/detail.vue'),
			meta: {
				level: 3,
				menuName: '非遗项目方针政策',
				menuId: 'A_G_3'
			},
		}, {
			path: "/lch/protect/:contentId",
			name: "lchProtectDetail",
			component: () => import( /* webpackChunkName: "lchPublicityDetail" */ '../views/lch/protect/detail.vue'),
			meta: {
				level: 3,
				menuName: '非遗传承保护',
				menuId: 'A_G_4'
			},
		}, {
			path: "/lch/intro/:contentId",
			name: "lchIntroDetail",
			component: () => import( /* webpackChunkName: "lchIntroDetail" */
				'../views/lch/intro/detail.vue'),
			meta: {
				level: 3,
				menuName: '非遗介绍',
				menuId: 'A_G_1'
			},
		}]

		}]
	}, 
	{
		path: "/about",
		name: "about",
		component: Main,
		redirect: '/about/index',
		meta: {
			menuName: '关于文化馆',
			isMenu: true,
			menuId: 'H'
		},
		children: [{
			path: "index",
			name: "aboutIndex",
			component: () => import( /* webpackChunkName: "aboutIndex" */ '../views/about/index.vue'),
			redirect: '/about/survey',
			children: [{
				path: "/about/survey",
				name: "aboutSurvey",
				component: () => import( /* webpackChunkName: "aboutIntro" */ '../views/about/survey/index.vue'),
				meta: {
					level: 2,
					mode: 3,
					menuName: '大兴文化馆概况',
					menuId: 'A_H1'
				},
			}, {
				path: "/about/intro",
				name: "aboutIntro",
				component: () => import( /* webpackChunkName: "aboutIntro" */ '../views/about/intro/index.vue'),
				meta: {
					level: 2,
					mode: 3,
					menuName: '总分馆体系介绍',
					menuId: 'A_H2'
				},
			}, {
				path: "/about/partyBuildingGarden",
				name: "partyBuildingGarden",
				component: () => import( /* webpackChunkName: "partyBuildingGarden" */
					'../views/about/partyBuildingGarden/index.vue'),
				meta: {
					level: 2,
					mode: 3,
					menuName: '党建园地',
					menuId: 'A_H3'
				},
			}, {
				path: "/about/partyBuildingGarden/:contentId",
				name: "PartyBuildingGardenDetail",
				component: () => import( /* webpackChunkName: "PartyBuildingGardenDetail" */
					'../views/about/partyBuildingGarden/detail.vue'),
				meta: {
					level: 3,
					menuName: '党建园地',
					menuId: 'A_H3_1'
				},
			}, {
				path: "/about/libraryTeam",
				name: "libraryTeam",
				component: () => import( /* webpackChunkName: "culturalCloudFront" */
					'../views/about/libraryTeam/index.vue'),
				meta: {
					level: 2,
					mode: 3,
					menuName: '馆办团队',
					menuId: 'A_H4'
				},
			}, {
				path: "/about/libraryTeam/:contentId",
				name: "libraryTeamDetail",
				component: () => import( /* webpackChunkName: "libraryTeamDetail" */
					'../views/about/libraryTeam/detail.vue'),
				meta: {
					level: 3,
					mode: 3,
					menuName: '馆办团队',
					menuId: 'A_H4'
				},
			}, {
				path: "/about/libraryPublications",
				name: "libraryPublications",
				component: () => import( /* webpackChunkName: "culturalCloudFront" */
					'../views/about/libraryPublications/index.vue'),
				meta: {
					level: 2,
					mode: 3,
					menuName: '馆办刊物',
					menuId: 'A_H5'
				},
			}, {
				path: "/about/libraryPublications/:contentId",
				name: "libraryPublicationsDetail",
				component: () => import( /* webpackChunkName: "culturalCloudFront" */
					'../views/about/libraryPublications/detail.vue'),
				meta: {
					level: 3,
					menuName: '馆办刊物',
					menuId: 'A_H5_1'
				},
			}, 
			// {
			// 	path: "/about/culturalCloudFront",
			// 	name: "culturalCloudFront",
			// 	component: () => import( /* webpackChunkName: "culturalCloudFront" */
			// 		'../views/about/culturalCloudFront/index.vue'),
			// 	meta: {
			// 		level: 2,
			// 		mode: 3,
			// 		menuName: '馆办云阵地',
			// 		menuId: 'A_H6'
			// 	},
			// }, 
			{
				path: "/about/contact",
				name: "contact",
				component: () => import( /* webpackChunkName: "culturalCloudFront" */
					'../views/about/contact/index.vue'),
				meta: {
					level: 2,
					mode: 3,
					menuName: '联系方式',
					menuId: 'A_H7'
				},
			}, {
				path: "/about/app",
				name: "app",
				component: () => import( /* webpackChunkName: "culturalCloudFront" */
					'../views/about/app/index.vue'),
				meta: {
					level: 2,
					mode: 3,
					menuName: '大兴数字文化馆',
					menuId: 'A_H8'
				},
			}]
		}]
	},
	{
		path: "/circles",
		name: "circles",
		component: Main,
		redirect: '/circles/list',
		meta: {
			menuName: '文化圈子',
			isMenu: true,
			menuId: 'E'
		},
		children: [{
			path: "mine",
			name: "circlesMine",
			component: () => import( /* webpackChunkName: "privateLetter" */
				'../views/cultureCircles/index.vue'),
			redirect: 'mine/index',
			children: [{
				path: "privateLetter",
				name: "privateLetter",
				component: () => import( /* webpackChunkName: "privateLetter" */
					'../views/cultureCircles/privateLetter.vue'),
				meta: {
					level: 3,
					menuId: 'A_E_1',
					menuName: '好友私信'
				},
			}, {
				path: "privateLetter/:userId",
				name: "privateLetterDetail",
				component: () => import( /* webpackChunkName: "privateLetterDetail" */
					'../views/cultureCircles/privateLetterDetail.vue'),
				meta: {
					level: 3,
					menuId: 'A_E_1',
					menuName: '好友私信'
				},
			}, {
				path: "systemMessage",
				name: "systemMessage",
				component: () => import( /* webpackChunkName: "systemMessage" */
					'../views/cultureCircles/systemMessage.vue'),
				meta: {
					level: 3,
					menuId: 'A_E_2',
					menuName: '系统私信'
				},
			}, {
				path: "circles",
				name: "myCircles",
				component: () => import( /* webpackChunkName: "myCircles" */ '../views/cultureCircles/mine.vue'),
				meta: {
					level: 3,
					menuId: 'A_E_3',
					menuName: '我的圈子'
				},
			}, {
				path: "collection",
				name: "collection",
				component: () => import( /* webpackChunkName: "collection" */ '../views/cultureCircles/collection.vue'),
				meta: {
					level: 3,
					mode: 3,
					menuId: 'A_E_4',
					menuName: '我的收藏'
				},
			}, {
				path: "interaction",
				name: "interaction",
				component: () => import( /* webpackChunkName: "interaction" */
					'../views/cultureCircles/interaction.vue'),
				meta: {
					level: 3,
					menuId: 'A_E_5',
					menuName: '我的互动'
				},
			}]
		}, {
			path: "detail/:userId",
			name: "circlesDetail",
			component: () => import( /* webpackChunkName: "circlesDetail" */ '../views/cultureCircles/detail.vue'),
			meta: {
				level: 3,
				hideBreadcrumb: true,
				menuId: 'A_E1_1',
				menuName: '圈友详情'
			}
		}, {
			path: "list",
			name: "circlesList",
			component: () => import( /* webpackChunkName: "circlesList" */ '../views/cultureCircles/list.vue'),
			meta: {
				level: 3,
				menuId: 'A_E_6',
				menuName: '文化圈子'
			}
		}, {
			path: "follow",
			name: "circlesFollow",
			component: () => import( /* webpackChunkName: "circlesFollow" */ '../views/cultureCircles/follow.vue'),
			meta: {
				level: 3,
				menuId: 'A_E1_1',
				menuName: '我的关注'
			}
		}, {
			path: "fans",
			name: "circlesFans",
			component: () => import( /* webpackChunkName: "circlesFans" */ '../views/cultureCircles/fans.vue'),
			meta: {
				level: 3,
				menuId: 'A_E1_2',
				menuName: '我的粉丝'
			}
		}]
	}, 
	{
		path: "/login",
		name: "login",
		component: () => import( /* webpackChunkName: "loginMain" */
			'../views/login.vue'),
		meta: {
			mode: 99
		}
	},
	{
		path: "/register",
		name: "register",
		component: () => import( /* webpackChunkName: "registerMain" */
			'../views/register.vue'),
		meta: {
			level: 2,
			mode: 99
		}
	},
	{
		path: "/reset",
		name: "reset",
		component: () => import( /* webpackChunkName: "resetMain" */
			'../views/reset.vue'),
		meta: {
			level: 2,
			mode: 99
		}
	},
	{
		path: "/agreement",
		name: "agreement",
		component: () => import( /* webpackChunkName: "resetMain" */
			'../views/agreement.vue'),
		meta: {
			level: 2,
			mode: 99
		}
	},
	{
		path: "/setting",
		name: "setting",
		redirect: '/setting/index',
		component: Main,
		meta: {
			isMenu: true,
			menuId: 'I',
			level: 2,
			mode: 'black',
			menuName: '我的设置'
		},
		children: [{
			path: "index",
			name: "settingIndex",
			redirect: '/setting/mine',
			component: () => import( /* webpackChunkName: "settingIndex" */ '../views/setting/index.vue'),
			meta: {
				level: 2,
				mode: 'black',
				menuName: '我的设置',
				menuId: 'A_I_1',
			},
			children: [{
				path: "/setting/signIn",
				name: "signIn",
				component: () => import( /* webpackChunkName: "settingMine" */ '../views/setting/signIn.vue'),
				meta: {
					level: 2,
					mode: 'black',
					menuName: '签到得积分',
					menuId: 'A_I1'
				},
			}, {
				path: "/setting/mine",
				name: "settingMine",
				component: () => import( /* webpackChunkName: "settingMine" */ '../views/setting/mine.vue'),
				meta: {
					// level: 2,

					mode: 'black',
					menuName: '个人设置',
					menuId: 'A_I2'
				},
			}, {
				path: "/setting/safe",
				name: "settingSafe",
				component: () => import( /* webpackChunkName: "settingSage" */ '../views/setting/safe.vue'),
				meta: {
					level: 2,
					mode: 'black',
					menuName: '安全设置',
					menuId: 'A_I3'
				},
			}, {
				path: "/setting/collection",
				name: "settingCollection",
				component: () => import( /* webpackChunkName: "settingSage" */ '../views/setting/collection.vue'),
				meta: {
					level: 2,
					mode: 'black',
					menuName: '我的收藏',
					menuId: 'A_I_4'
				},
			}, {
				path: "/setting/activity",
				name: "settingActivity",
				component: () => import( /* webpackChunkName: "settingNotice" */ '../views/setting/activity.vue'),
				meta: {
					level: 3,
					mode: 'black',
					menuName: '已报名活动',
					menuId: 'A_I_5'
				},
			}, {
				path: "/setting/notice",
				name: "settingNotice",
				component: () => import( /* webpackChunkName: "settingNotice" */ '../views/setting/notice.vue'),
				meta: {
					level: 3,
					mode: 'black',
					menuName: '系统通知',
					menuId: 'A_I_6'
				},
			}, {
				path: "/setting/notice/:contentId",
				name: "settingNoticeDetail",
				component: () => import( /* webpackChunkName: "settingNotice" */ '../views/setting/noticeDetail.vue'),
				meta: {
					level: 3,
					mode: 'black',
					menuName: '系统通知',
					menuId: 'A_I_7'
				},
			}, {
				path: "/setting/changePhone",
				name: "changePhone",
				component: () => import( /* webpackChunkName: "changePhone" */ '../views/setting/changePhone.vue'),
				meta: {
					level: 3,
					mode: 'black',
					menuName: '更换手机号码',
					menuId: 'A_I_8'
				},
			}]
		}]
	}
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})


export default router
